/**
 * Централизованные маршруты приложения
 */
export const ROUTES = {
  // Главная страница
  HOME: '/',
  
  // Гости (QR регистрация)
  GUEST_QR_REGISTRATION: '/guest/:adminId',
  GUEST_MANUAL_REGISTRATION: '/guest/:adminId/manual',
  GUEST_PHOTO_REGISTRATION: '/guest/:adminId/photo',
  GUEST_REGISTRATION_SUCCESS: '/guest/:adminId/success',
  
  // Администраторы отелей
  ADMIN_LOGIN: '/admin-login',
  ADMIN_REGISTER_OPEN: '/admin-register-open',
  ADMIN_REGISTER: '/admin-register',
  ADMIN_LOGIN_CODE: '/admin-login-code',
  ADMIN_VERIFY_EMAIL_SENT: '/admin-verify-email-sent',
  ADMIN_VERIFY_EMAIL: '/admin-verify-email',
  ADMIN_SUBSCRIPTION_SELECT: '/admin-subscription-select',
  ADMIN_PAYMENT_SUCCESS: '/admin/payment-success',
  ADMIN_DASHBOARD: '/admin/dashboard',
} as const

/**
 * Названия страниц для UI
 */
export const PAGE_TITLES = {
  [ROUTES.HOME]: 'Главная',
  [ROUTES.ADMIN_LOGIN]: 'Вход для администраторов',
  [ROUTES.ADMIN_REGISTER_OPEN]: 'Регистрация отеля',
  [ROUTES.ADMIN_REGISTER]: 'Регистрация по коду',
  [ROUTES.ADMIN_DASHBOARD]: 'Панель администратора',
  [ROUTES.ADMIN_SUBSCRIPTION_SELECT]: 'Выбор тарифа',
} as const
